<template>
  <div class="auth__head d-flex flex-column justify-content-center">
    <div class="d-flex align-items-center justify-content-center" style="margin-bottom: 48px">
      <img :src="require('@/assets/images/login/logo-icon.svg')" alt="" width="28" height="28"/>
      <img :src="require('@/assets/images/login/logo-wordmark.svg')" alt="getpica.com" width="87" height="14" class="ml-2"/>
      <img :src="require('@/assets/images/login/dashboard.svg')" alt="dashboard" width="70" height="10" class="ml-2"/>
    </div>
    <h1 class="font-weight-semi-bold">{{ title }}</h1>
    <p class="text-center" v-if="subtitle">{{ subtitle }}</p>
  </div>
</template>
<script>

export default {
  name: "OnBoardingHeader",
  props: {
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    }
  }
}
</script>


<style scoped>

</style>